// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/hooks/useCampanhas.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { campanhaService } from '../services/campanhaService';
import type { CriarCampanhaRequest, AtualizarCampanhaRequest } from '../types';

export function useCampanhas() {
  const queryClient = useQueryClient();
  const query = useQuery({ queryKey: ['campanhas'], queryFn: () => campanhaService.getAll() });
  const invalidate = () => queryClient.invalidateQueries({ queryKey: ['campanhas'] });

  const create = useMutation({
    mutationFn: (req: CriarCampanhaRequest) => campanhaService.create(req),
    onSuccess: invalidate,
  });
  const update = useMutation({
    mutationFn: ({ id, req }: { id: number; req: AtualizarCampanhaRequest }) => campanhaService.update(id, req),
    onSuccess: invalidate,
  });
  const remove = useMutation({
    mutationFn: (id: number) => campanhaService.delete(id),
    onSuccess: invalidate,
  });
  const disparar = useMutation({
    mutationFn: (id: number) => campanhaService.disparar(id),
    onSuccess: invalidate,
  });
  const reprocessar = useMutation({
    mutationFn: (id: number) => campanhaService.reprocessar(id),
    onSuccess: invalidate,
  });

  return { query, create, update, remove, disparar, reprocessar };
}
